export default {
  name: "loader-box",

  data() {
    return {
      message: "Finding locations for your move"
    };
  },

  props: {
    isActive: {
      type: String,
      default: ""
    }
  },

  watch: {
    isActive() {
      this.runTimeOut();
    }
  },

  methods: {
    runTimeOut() {
      let self = this;

      // this.message = "Finding locations for your move";

      setTimeout(function() {
        self.message = "Running algorithm with 300 data points";
      }, 1000);

      setTimeout(function() {
        self.message = "Searching 302,487 off - market homes";
      }, 2000);

      setTimeout(function() {
        self.message = "Saving your results...";
      }, 3000);

      // setTimeout(function() {
      // }, 5000);
      self.message = "Finding locations for your move";
    }
  }
};
// function onReady(callback) {
//   setTimeout(function () {
//     // Do something after 1 second
//     document.getElementById('loading').innerHTML = "Running algorithm with 300 data points";
//   }, 1000);
//   setTimeout(function () {
//     // Do something after 1 second
//     document.getElementById('loading').innerHTML = "Searching 302,487 off-market homes";
//   }, 2000);
//   setTimeout(function () {
//     // Do something after 1 second
//     document.getElementById('loading').innerHTML = "Saving your results...";
//   }, 3000);
//   var intervalID = window.setInterval(checkReady, 1000);
//   function checkReady() {
//     if (document.getElementsByTagName('body')[0] !== undefined) {
//       window.clearInterval(intervalID);
//       callback.call(this);
//     }
//   }
// }

// function show(id, value) {
//   // document.getElementById(id).style.display = value ? 'block' : 'none';
// }
// onReady(function () {
//   // show('page', true);
//   show('loading', false);
// });
